import React from "react";
import {
  AbsoluteFill,
  interpolate,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import StackChip from "../components/StackChip";
import { PROJECTS, STACK_CLUSTERS } from "../data/resume";

// Cluster anchor positions in the 1920×1080 design space.
const CLUSTER_POSITIONS = [
  { x: 330, y: 330 },
  { x: 1590, y: 330 },
  { x: 330, y: 790 },
  { x: 1590, y: 790 },
  { x: 960, y: 620 },
];

// Scene 6 — Constellation (88–95%): every stack chip flies out from the
// center and clusters by discipline; all project colors present.
const Scene6Constellation: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  let chipIndex = 0;

  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#181818",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 90,
          left: 0,
          right: 0,
          textAlign: "center",
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 600,
          fontSize: 54,
          color: "white",
          opacity: interpolate(frame, [0, 10], [0, 1], {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
          }),
        }}
      >
        Eight years, one stack constellation
      </div>
      {STACK_CLUSTERS.map((cluster, c) => {
        const pos = CLUSTER_POSITIONS[c];
        const labelPop = spring({
          frame: frame - (6 + c * 3),
          fps,
          config: { damping: 13, stiffness: 150 },
        });
        return (
          <div key={cluster.label}>
            <div
              style={{
                position: "absolute",
                left: pos.x,
                top: pos.y - 120,
                translate: "-50% -50%",
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 34,
                letterSpacing: 6,
                color: "white",
                opacity: labelPop,
                scale: String(labelPop),
              }}
            >
              {cluster.label.toUpperCase()}
            </div>
            <div
              style={{
                position: "absolute",
                left: pos.x,
                top: pos.y,
                translate: "-50% -50%",
                width: 480,
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              {cluster.chips.map((chip) => {
                const color =
                  PROJECTS[chipIndex % PROJECTS.length].color;
                const delay = 10 + (chipIndex % 12) * 2 + c * 2;
                chipIndex += 1;
                const fly = spring({
                  frame: frame - delay,
                  fps,
                  config: { damping: 15, stiffness: 110 },
                });
                return (
                  <div
                    key={chip}
                    style={{
                      translate: `${(960 - pos.x) * (1 - fly)}px ${
                        (540 - pos.y) * (1 - fly)
                      }px`,
                      opacity: interpolate(fly, [0, 0.25], [0, 1], {
                        extrapolateRight: "clamp",
                      }),
                    }}
                  >
                    <StackChip text={chip} color={color} fontSize={24} />
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </AbsoluteFill>
  );
};

export default Scene6Constellation;
